<template>
  <app-page-container :title="`ماموریت های جاری -
                      ${currentMission115MainList.length}`">
    <template v-slot:header>
      <v-col cols="4" class="">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3 mr-n16"></v-text-field>
      </v-col>

      <div class="leftItemTop">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon id="iconDatabase" size="28" color="#464646" @click="openColumnManager" v-bind="attrs" v-on="on">
              mdi-database-edit
            </v-icon>
          </template>
          <span>
            چیدمان جدول
          </span>
        </v-tooltip>
        <div class="switchStatus">
          <span class="txt1">ماموریت های من : </span>
          <v-switch v-model="myMission" flat inset dense class="mt-0 " color="#00CA2C" hide-details v-bind="attrs"
            v-on="on"></v-switch>
        </div>
        <v-btn rounded color="darkColor" dark @click="addHandleMission()" class="ma-0 normal-letter-spacing">
          <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
          ایجاد ماموریت
        </v-btn>
      </div>
      <!-- <v-col cols="2" class="text-left"> -->
      <!-- </v-col> -->
    </template>
    <template v-slot:body>
      <section>
        <v-row no-gutters class="background-main mx-2">
          <v-col cols="12">
            <v-card elevation="0" class="body-card card-width">
              <v-row no-gutters>
                <v-col cols="12">
                  <template>
                    <v-data-table id="mission_table" :defaultHeaders="currentMission115TableHeader"
                      :headers="currentHeaders.filter(h => h.isActive !== false)"
                      :cell-props="({ header }) => ({ style: { width: header.width, minWidth: header.width } })"
                      :items="filteredMissionList" :items-per-page="-1" fixed-header height="80vh"
                      :hide-default-footer="true" class="elevation-0 table-115" dense :search="searchTitle"
                      @dblclick:row="showEdit155MissionModal" @contextmenu:row="rightClickHandler">
                      <template v-slot:[`item.ambulanceStatus`]="{ item }">
                        <app-wrap-text :text="item?.ambulanceStatus ?? ''" />
                      </template>
                      <template v-slot:[`item.user`]="{ item }">
                        <app-wrap-text :text="item?.user ?? ''" />
                      </template>
                      <template v-slot:[`item.chiefComplaintText`]="{ item }">
                        <app-wrap-text :text="item?.chiefComplaintText ?? ''" />
                      </template>
                      <template v-slot:[`item.chiefComplaintNote`]="{ item }">
                        <app-wrap-text :text="item?.chiefComplaintNote ?? ''" />
                      </template>
                      <template v-slot:[`item.hospital`]="{ item }">
                        <td>
                          <app-wrap-text :text="item?.hospital ?? ''" />
                        </td>
                      </template>
                      <template v-slot:[`item.phone`]="{ item }">
                        <td>
                          <app-wrap-text :text="item?.phone ?? ''" />
                        </td>
                      </template>
                      <template v-slot:[`item.icon`]="{ item }">
                        <v-tooltip top v-if="item.toopakColor">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" :color="item.toopakColor"
                              @click="removeTopack(item.toopakId)">
                              mdi-circle
                            </v-icon>
                          </template>
                          <span>برچسب دار</span>
                        </v-tooltip>
                        <v-tooltip top v-else-if="item.iconType == 'before800'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" :color="item.iconColor">
                              mdi-email-arrow-right
                            </v-icon>
                          </template>
                          <span>ارسال به 800</span>
                        </v-tooltip>
                        <v-tooltip top v-else-if="item.iconType == '800'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" :color="item.iconColor">
                              mdi-email-newsletter
                            </v-icon>
                          </template>
                          <span>مشاهده توسط 800</span>
                        </v-tooltip>
                        <v-tooltip top v-else-if="item.iconType == 'send'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" :color="item.iconColor">
                              mdi-ambulance
                            </v-icon>
                          </template>
                          <span>اعزام آمبولانس</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.address`]="{ item }">
                        <v-row dir="rtl" v-if="item.hasAddressChanged == true" class="bottom-list-address" no-gutters>
                          <v-col cols="12" class="text-center">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <app-wrap-text v-on="on" v-bind="attrs" :text="item?.address ?? ''" />
                              </template>
                              <span>تغییر آدرس محل فوریت</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row v-if="item.hasAddressChanged == false" dir="rtl">
                          <v-col cols="12" class="text-center">
                            <app-wrap-text v-on="on" v-bind="attrs" :text="item?.address ?? ''" />
                          </v-col>
                        </v-row>
                      </template>
                      <template v-slot:[`item.cheifComlaint`]="{ item }">
                        <div dir="rtl" class="flex gap-1 items-center justify-center">
                          <v-icon :color="item.iconColor" v-if="item.rank == 3">
                            mdi-numeric-1-circle mdi-18px
                          </v-icon>
                          <v-icon :color="item.iconColor" v-if="item.rank == 2">
                            mdi-numeric-2-circle mdi-18px
                          </v-icon>
                          <v-icon :color="item.iconColor" v-if="item.rank == 1">
                            mdi-numeric-3-circle mdi-18px
                          </v-icon>
                          <v-icon :color="item.iconColor" v-if="item.rank == 0">
                            mdi-numeric-4-circle mdi-18px
                          </v-icon>

                          <app-wrap-text :text="item?.cheifComlaint ?? ''" />
                        </div>
                      </template>
                      <template v-slot:[`item.ambulance`]="{ item }">
                        <v-row v-if="item.hasLackOfCode == true" class="bottom-list-lake-off-code" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <app-wrap-text v-bind="attrs" v-on="on" :text="item?.ambulance ?? ''" />
                              </template>
                              <span>فاقدی</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row v-if="item.hasLackOfCode == false">
                          <v-col cols="12" class="text-center">
                            <app-wrap-text :text="item?.ambulance ?? ''" />
                          </v-col>
                        </v-row>
                      </template>
                      <template v-slot:[`item.missionStatus`]="{ item }">
                        <v-row v-if="item.missionStatus == '10-33'" class="bottom-list-status-10-99" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.missionStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else-if="item.missionStatus == '10-99'" class="bottom-list-status-10-99" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.missionStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else-if="item.missionStatus == '10-19'" class="bottom-list-status-10-99" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.missionStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else-if="item.missionStatus == '10-12'" class="bottom-list-status-10-99" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.missionStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else-if="item.missionStatus.startsWith('بیمارستان')" class="bottom-list-status-10-99"
                          no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.missionStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" class="text-center">
                            <app-wrap-text :text="item?.missionStatus ?? ''" />
                          </v-col>
                        </v-row>
                      </template>
                      <template v-slot:[`item.codeStatus`]="{ item }">
                        <v-row v-if="item.codeStatus == '10-33'" class="bottom-list-status-10-99" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.codeStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else-if="item.codeStatus == '10-99'" class="bottom-list-status-10-99" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.codeStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else-if="item.codeStatus == '10-19'" class="bottom-list-status-10-99" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.codeStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else-if="item.codeStatus == '10-12'" class="bottom-list-status-10-99" no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.codeStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else-if="item.codeStatus.startsWith('بیمارستان')" class="bottom-list-status-10-99"
                          no-gutters>
                          <v-col cols="12" class="text-center mt-1">
                            <app-wrap-text :text="item?.codeStatus ?? ''" />
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" class="text-center">
                            <app-wrap-text :text="item?.codeStatus ?? ''" />
                          </v-col>
                        </v-row>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </section>
    </template>
    <template v-slot:append>
      <section>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
        <v-dialog v-model="edit115MissionModal" width="85%" persistent>
          <edit115-mission-component v-if="edit115MissionModal" :missionPhoneId="missionPhoneId" :missionId="missionId"
            :type="'fromMainList'" :phoneId="phoneId" :callerId="null"></edit115-mission-component>
        </v-dialog>
        <column-manager-dialog :is-reverse="false" v-model="showColumnManager" :headers="currentHeaders"
          :defaultHeaders="currentMission115TableHeader" :fixedValues="['icon']" @submit="applyNewHeaders" />
      </section>
      <section>
        <v-menu v-model="showMenu" :position-x="x" :position-y="y" :close-on-content-click="closeOnContentClick"
          absolute offset-y>
          <v-list dense>
            <v-list-item-group>
              <v-list-item v-for="(item, index) in rightClickItems" :key="index" dense>
                <v-list-item-icon>
                  <v-icon color="darkColor">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content v-if="item.title == 'جزئیات پرونده'" class="mr-n5">
                  <v-list-item-title class="text--white menu-items" @click="rightClickAction(item.title, null)">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس داخلی'">
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-text-field placeholder="شماره تماس" dense small v-model="iternalPhoneNumber">
                      <template v-slot:append-outer>
                        <v-btn x-small color="darkColor" dark class="py-3" @click="rightClickAction(item.title, null)">
                          <v-icon color="white">mdi-phone mdi-18px mdi-flip-h</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-list-group>
                </v-list-item-content>
                <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس خارجی'">
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-text-field placeholder="شماره تماس" dense small v-model="externalPhoneNumber">
                      <template v-slot:append-outer>
                        <v-btn x-small color="darkColor" dark class="py-3" @click="rightClickAction(item.title, null)">
                          <v-icon color="white">mdi-phone-forward mdi-18px mdi-flip-h</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-list-group>
                </v-list-item-content>
                <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با کد'">
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item @click="rightClickAction(item.title, codePhoneNumbers)">
                      <v-list-item-content>
                        <v-list-item-title class="mr-3">{{ codePhoneNumbers }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list-item-content>
                <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با مددجو'">
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item v-for="(sitem, index) in patientPhoneNumbers" :key="'c' + index"
                      @click="rightClickAction(item.title, sitem)">
                      <v-list-item-content>
                        <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <v-row no-gutters>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-3 mb-2 mr-6 ml-3">
              <v-icon class="ml-3" :color="color.color" v-for="color in colorTags" :key="color.id"
                @click="setToopackForMission(color)">
                mdi-circle
              </v-icon>
            </v-row>
          </v-list>
        </v-menu>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<script>
function watchClass(targetNode, classToWatch) {
  let lastClassState = targetNode.classList.contains(classToWatch);
  const observer = new MutationObserver((mutationsList) => {
    for (let i = 0; i < mutationsList.length; i++) {
      const mutation = mutationsList[i];
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const currentClassState = mutation.target.classList.contains(classToWatch);
        if (lastClassState !== currentClassState) {
          lastClassState = currentClassState;
          if (!currentClassState) {
            mutation.target.classList.add('sortHandle');
          }
        }
      }
    }
  });
  observer.observe(targetNode, { attributes: true });
}
import Sortable from 'sortablejs';
import throttle from 'lodash/throttle'; // rate-limits socket-driven refreshes; trailing:true guarantees the LAST signal is never dropped
import AppPageContainer from '@/components/app/PageContainer.vue';
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import Edit115MissionComponent from '@/components/115/Edit115MissionComponent.vue';
import AppWrapText from '@/components/app/wrapText.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import Mission115Helper from '@/Helpers/115/115MisionHelper.js';
import MissionPhoneMixin from '@/Mixins/Mission/MissionPhonesMixin';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import UserGridSettingsMixin from '@/Mixins/BaseInformation/UserGridSettingsMixin.js';
import ColumnManagerDialog from '../../components/800/ColumnManagerDialog.vue';
import '@/assets/styles/115.scss';
export default {
  name: 'MissionView115',
  directives: {
    'sortable-table': {
      inserted: (el, binding) => {
        el.querySelectorAll('th').forEach((draggableEl) => {
          // Need a class watcher because sorting v-data-table rows asc/desc removes the sortHandle class
          watchClass(draggableEl, 'sortHandle');
          draggableEl.classList.add('sortHandle');
        });
        Sortable.create(
          el.querySelector('tr'),
          binding.value ? { ...binding.value, handle: '.sortHandle' } : {},
        );
      },
    },
  },
  title: 'ماموریت های 115',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    AppWrapText,
    Edit115MissionComponent,
    AppPageContainer,
    ColumnManagerDialog
  },
  mixins: [
    pagination,
    ShearedMixin,
    snackBar,
    ShearedHelper,
    Mission115Helper,
    MissionPhoneMixin,
    CallMixin,
    UserGridSettingsMixin
  ],
  created() {
    this.$root.$refs.Mission115View = this;
    this.currentHeaders = [...this.currentMission115TableHeader];

    this.throttledMainList115 = throttle(this.getData, 1500, {
      leading: true,
      trailing: true,
    });

    this.$mainSignalr.bus.$on('MainList115', this.throttledMainList115);
    this.$mobileSignalr.bus.$on('MainList115', this.throttledMainList115);
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('MainList115', this.throttledMainList115);
    this.$mobileSignalr.bus.$off('MainList115', this.throttledMainList115);

    this.throttledMainList115.cancel();

    delete this.$root.$refs.Mission115View;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      myMission: false,
      missionListRefreshInFlight: false,
      missionListRefreshPending: false,
      showColumnManager: false,
      currentHeaders: [],
    };
  },
  methods: {
    mounte: function async() {
      this.getData();
      this.getAllUserGridSettingsFunction('MainList115').then((resolve) => {

        if (resolve?.length > 0) {
          let temp = resolve?.find((item) => item?.gridName == 'MainList115');
          if (temp?.settingsJson) {
            try {
              this.currentHeaders = JSON.parse(temp?.settingsJson);
            } catch (e) {
              this.currentHeaders = [...this.currentMission115TableHeader];
            }
          } else {
            this.currentHeaders = [...this.currentMission115TableHeader];
          }
        } else {
          this.currentHeaders = [...this.currentMission115TableHeader];
        }
      })
      const tables = document.getElementsByTagName('table');
      this.resizableGrid(tables[0]);
      this.getSystemSettingByClientComputer();
    },
    getData: async function () {
      if (this.missionListRefreshInFlight) {
        this.missionListRefreshPending = true;
        return;
      }
      this.missionListRefreshInFlight = true;
      try {
        await this.getListOfCurrentMissionFunction();
      } catch (error) {
        console.log('getData refresh error:', error);
      } finally {
        this.missionListRefreshInFlight = false;
        if (this.missionListRefreshPending) {
          this.missionListRefreshPending = false;
          this.getData();
        }
      }
    },
    sortTheHeadersAndUpdateTheKey(evt) {
      const headersTmp = this.currentMission115TableHeader;
      const oldIndex = evt.oldIndex;
      const newIndex = evt.newIndex;
      if (newIndex >= headersTmp.length) {
        let k = newIndex - headersTmp.length + 1;
        while (k--) {
          headersTmp.push(undefined);
        }
      }
      headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
      this.table = headersTmp;
      this.anIncreasingNumber += 1;
      setTimeout(() => {
        var mtable = document.getElementsByTagName('table');
        for (const item of mtable) {
          this.resizableGrid(item);
        }
      }, 700);
    },

    resizableGrid: function (table) {
      const element = document.getElementsByClassName('v-data-table__wrapper')[0];
      element.scrollLeft += element.scrollWidth + 30;
      var row = table.getElementsByTagName('tr')[0],
        cols = row ? row.children : undefined;
      if (!cols) return;
      table.style.overflow = 'scroll';
      table.style.tableLayout = 'fixed';

      var tableHeight = table.offsetHeight;

      var drag = { curCol: null, pageX: 0, curColWidth: 0, tableStartWidth: 0, delta: 0 };

      for (var p = 0; p < cols.length; p++) {
        cols[p].style.width = (cols[p].offsetWidth - paddingDiff(cols[p])) + 'px';
      }

      for (var i = 0; i < cols.length; i++) {
        var div = createDiv(tableHeight);
        cols[i].appendChild(div);
        cols[i].style.position = 'relative';
        setListeners(div);
      }

      function onMouseMove(e) {
        if (!drag.curCol) return;
        var diffX = e.pageX - drag.pageX;
        var newWidth = Math.max(40, drag.curColWidth - diffX);
        drag.delta = newWidth - drag.curColWidth;

        drag.curCol.style.width = newWidth + 'px';
        table.style.width = (drag.tableStartWidth + drag.delta) + 'px';

        if (drag.wrapperIsRtl) {
          // native RTL wrapper: the browser anchors content to the RIGHT edge and
          // measures scroll from it, so table growth extends LEFT on its own —
          // columns after the dragged one slide left naturally and the dragged
          // edge tracks the cursor. Any scroll compensation here CANCELS that
          // natural shift (this was the bug), so: do nothing.
        } else {
          table.style.marginLeft = (-drag.delta) + 'px';
        }
      }

      function onMouseUp() {
        if (drag.curCol && !drag.wrapperIsRtl && drag.delta) {
          table.style.marginLeft = '';
          drag.wrapper.scrollLeft = Math.max(0, drag.wrapperStartScroll + drag.delta);
        }
        drag.curCol = null;
        drag.delta = 0;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      function setListeners(div) {
        div.addEventListener('mousedown', function (e) {
          e.preventDefault();
          drag.curCol = e.target.parentElement;
          drag.pageX = e.pageX;
          drag.delta = 0;
          drag.curColWidth = drag.curCol.offsetWidth - paddingDiff(drag.curCol);
          drag.tableStartWidth = table.offsetWidth;

          drag.wrapper = table.closest('.v-data-table__wrapper') || element;
          drag.wrapperIsRtl = getStyleVal(drag.wrapper, 'direction') === 'rtl';
          drag.wrapperStartScroll = drag.wrapper.scrollLeft;

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        });

        div.addEventListener('mouseover', function (e) {
          e.target.style.borderLeft = '2px solid #0000ff';
        });

        div.addEventListener('mouseout', function (e) {
          e.target.style.borderLeft = '';
        });
      }

      function createDiv(height) {
        var div = document.createElement('div');
        div.style.top = 0;
        div.style.left = 0;
        div.style.width = '5px';
        div.style.position = 'absolute';
        div.style.cursor = 'col-resize';
        div.style.userSelect = 'none';
        div.style.height = height + 'px';
        return div;
      }

      function paddingDiff(col) {
        if (getStyleVal(col, 'box-sizing') == 'border-box') {
          return 0;
        }

        var padLeft = getStyleVal(col, 'padding-left');
        var padRight = getStyleVal(col, 'padding-right');
        return parseInt(padLeft) + parseInt(padRight);
      }

      function getStyleVal(elm, css) {
        return window.getComputedStyle(elm, null).getPropertyValue(css);
      }
    },
    getRealColumnWidths() {
      const table = document.querySelector('#mission_table table');
      if (!table) {
        return null;
      }

      const headerCells = table.querySelectorAll('thead tr th');
      if (!headerCells.length) {
        return null;
      }

      const widths = [];
      headerCells.forEach((th) => {
        const width = th.getBoundingClientRect().width;
        widths.push(Math.round(width));
      });
      return widths;
    },
    openColumnManager() {
      const realWidths = this.getRealColumnWidths();

      if (realWidths) {
        const headersWithWidth = this.currentHeaders.map((h, index) => ({
          ...h,
          width: realWidths[index] ? realWidths[index] : (h.width || 120),
        }));

        this.currentHeaders = headersWithWidth;
      }

      this.showColumnManager = true;
      const icon = document.getElementById('iconDatabase');
      if (icon) icon.blur();
    },
    applyNewHeaders(newHeaders) {
      this.currentHeaders = newHeaders;
      this.setUserGridSettingFunction({
        gridName: "MainList115",
        settingsJson: JSON.stringify(newHeaders)
      })
    },
  },
  computed: {
    filteredMissionList() {
      if (!this.currentMission115MainList?.length) return [];

      if (!this.myMission) return this.currentMission115MainList;

      const currentUserId = this.$store.state.userModule.userId;
      return this.currentMission115MainList.filter(
        (item) => item?.creationUserId === currentUserId
      );
    },
    currentMission115TableFilterList() {
      return this.currentMission115MainList.filter((u) => {
        return (
          u.ambulance.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.address.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.cheifComlaint.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.missionStatus.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.ambulanceStatus.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.hospital.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.phone.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.user.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.iconText.toLowerCase().includes(this.searchTitle.toLowerCase())
        );
      });
    },
  },
  watch: {
    currentMission115MainList: function (current) {
      console.log(current);
    },
  },
};
</script>
<style lang="scss">
.w-full {
  width: 100%;
}

.table-title {
  position: absolute;
  top: 0;
  right: 0;
  width: 271px;
  height: 51px;
}

#mission_table {
  .v-data-table-header {
    tr {
      position: sticky !important;
      top: 0 !important;
      left: 0 !important;
      z-index: 1;

      th:last-of-type {
        background-color: white !important;
      }
    }
  }
}
</style>
<style scoped>
>>>.table-115 .v-data-table__wrapper table {
  table-layout: fixed;
}

.leftItemTop {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  margin-right: auto;
  margin-left: 35px;
}

.switchStatus {
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  /* margin-bottom: 13px;
  margin-left: 25px; */
}

.switchStatus .txt1 {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}

.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 100% !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 100% !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 100% !important;
  }
}

.bottom-list-address {
  background: #9fe2ff !important;
  border-radius: 10px !important;
}

.bottom-list-lake-off-code {
  /* background: #e2e2e2 !important; */
  background: #f8eaff !important;
  border-radius: 10px !important;
}

.bottom-list-status-10-99 {
  background: #ff9c78 !important;
  border-radius: 5px !important;
  color: white;
}

.bottom-list-status-10-33 {
  background: #ffd89b !important;
  border-radius: 10px !important;
}


>>>.table-115 td {
  border-right: 1px solid grey !important;
}

>>>.table-115 th {
  border-right: 1px solid grey !important;
}

>>>.table-115 .v-data-table__wrapper table tbody tr td {
  font-size: 15px !important;
  font-weight: 600;
  color: #212121 !important;
}

>>>.table-115 .v-data-table__wrapper table thead tr th {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #212121 !important;
}

>>>.truncate {
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>>th {
  position: sticky !important;
  top: 0 !important;
}
</style>
